module.exports = __webpack_public_path__ + "static/img/2areaB_6.da2cb4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_6.png
// module id = 1158
// module chunks = 1